import {
    TOGGLE_MENU,
    HTTP_REQUEST,
    FEATURED_URL,
    FEEDBACK_REQUEST,
    FEEDBACK_SUCCESS,
    FEEDBACK_ERROR,
    FEATURED_REQUEST_INIT,
    FEATURED_REQUEST_SUCCESS,
    FEATURED_REQUEST_ERROR,
    SELECT_CHARITY,
    RESET_GLOBAL_STATE,
    TRACK_URL
} from '../constants/constants.js';

import axios from 'axios';

const initialState = {
    menuToggled:false,
    selectedCharity:{},
    featuredCharities:[]
};

export default function AppReducer(state = initialState, action) {
	switch(action.type) {
        case FEATURED_REQUEST_INIT: return {...state, loading:true }
        case FEATURED_REQUEST_SUCCESS: return {...state, loading:false, featuredCharities:[...action.payload] }
        case FEATURED_REQUEST_ERROR: return {...state, loading:false, error: action.error }
        case SELECT_CHARITY: return {...state, selectedCharity: action.payload }
        case HTTP_REQUEST: return {...state, loading:true }
        case FEEDBACK_REQUEST: return {...state, loading:true }
        case FEEDBACK_SUCCESS: return {...state, loading:false, feedbackSubmitted:true }
        case FEEDBACK_ERROR: return {...state, loading:false, error:payload.error }
        case HTTP_REQUEST: return {...state, loading:true }
        case RESET_GLOBAL_STATE: { return initialState; }
        // case '@@router/LOCATION_CHANGE': {
        //      if(!window.ga || !ga.create) {
        //         axios.get(TRACK_URL + '?query=' + encodeURIComponent(JSON.stringify(action.payload)));
        //      }
        //      return state;
        // }
        default: return state
	}
}



// WEBPACK FOOTER //
// ./reducers/AppReducer.js